import type { WhitelabelOnboardingStatus as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util/takePayload';
import * as BrandedAccount from './BrandedAccount';
import * as CloudflareHostnameStatus from './CloudflareHostnameStatus';
import * as DnsRecordCheck from './DnsRecordCheck';
import * as OnboardingState from './OnboardingState';

export type OnboardingStatus = {
  configId: number;
  domain: string;
  state: OnboardingState.OnboardingState;
  accounts: BrandedAccount.BrandedAccount[];
  cloudflareHostnames: CloudflareHostnameStatus.CloudflareHostnameStatus[];
  dnsRecords: DnsRecordCheck.DnsRecordCheck[];
  checkedAt?: string;
};

export const fromGql = (item: GQLItem): OnboardingStatus => ({
  ...take<OnboardingStatus>(item, 'configId', 'domain', 'checkedAt'),
  state: item.state as OnboardingState.OnboardingState,
  accounts: BrandedAccount.fromGqlCollection(item.accounts),
  cloudflareHostnames: CloudflareHostnameStatus.fromGqlCollection(item.cloudflareHostnames),
  dnsRecords: DnsRecordCheck.fromGqlCollection(item.dnsRecords),
});
